import React, { memo } from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ContactMethodCardProps } from "./types";

const ContactMethodCard: React.FC<ContactMethodCardProps> = memo(
  ({
    method,
    title,
    description,
    buttonText,
    isSelected,
    isRecommended = false,
    showContactInfoForm,
    hours,
    onSelect,
    onRequest,
  }) => (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        border: "1px solid #D5D6D7",
        boxShadow: isSelected ? 4 : "none",
        cursor: showContactInfoForm ? "default" : "pointer",
        opacity: showContactInfoForm ? 0.6 : 1,
        pointerEvents: showContactInfoForm ? "none" : "auto",
      }}
      onClick={() => !showContactInfoForm && onSelect(method)}
    >
      <CardContent sx={{ p: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Box sx={{ display: "flex", flexDirection: "column", mb: 0.5 }}>
              {isRecommended && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    border: "1px solid #0009",
                    px: 1,
                    borderRadius: 5,
                    mb: 2.5,
                    width: "fit-content",
                  }}
                >
                  {isRecommended ? "Recommended" : ""}
                </Typography>
              )}
              <Typography variant="h6" component="div">
                {title}
              </Typography>
            </Box>
            <Typography color="text.secondary" variant="body2">
              {description}
            </Typography>
            {hours && (
              <Typography color="text.secondary" variant="body2" sx={{ mt: 1 }}>
                {hours}
              </Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={onRequest}
              disabled={!isSelected}
              sx={{ mt: 2, textTransform: "none", borderRadius: "4px", px: 2 }}
              endIcon={<ArrowForwardIosIcon fontSize="small" />}
            >
              {buttonText}
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
);

export default ContactMethodCard;
